module.exports = __webpack_public_path__ + "img/sec-03-mirae.31d7c11a.svg";